// extracted by mini-css-extract-plugin
export default {"questionList":"styles_questionList__hd59N"};